import { createAppConstants } from '@hwm/ui-lib/ui/styles';

export const styleConstants = createAppConstants(
  {},
  {
    colors: {
      primaryColor: '#00A9E0',
      primaryDark: '#002F6C',
      yellow: '#EEC100',
      black: '#000000',
      text: '#000000DE',
      emptyChart: '#999',
      royalBlue: '#4169e1',
      sites: {
        flatline: '#c2224f',
        quiet: '#EEC100',
        pressureFault: '#4169e1',
        ok: '#18e874',
      },
    },
    chartTooltip: {
      fontFamily: 'Ubuntu Sans, sans-serif',
      fontSize: '12px',
      padding: '4px 10px 4px 10px',
      color: '#008ffb',
    },
  }
);
